import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CtaBand } from "../components/CtaBand";
import { SEBRING_GARAGE } from "../data/site";

export default function SebringGarage() {
  return (
    <div data-testid="sebring-garage-page">
      <PageHeader
        overline="Sebring Garage — Sebring, Florida"
        lines={["Your base", "at Sebring."]}
        description={SEBRING_GARAGE.intro}
        image={SEBRING_GARAGE.gallery[0].src}
        imageAlt={SEBRING_GARAGE.gallery[0].alt}
      />

      <section data-testid="garage-services" className="border-t border-neutral-200 bg-white">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          <Reveal>
            <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946] md:text-[11px]">
              What the garage offers
            </p>
            <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-[#111111] sm:text-4xl lg:text-5xl">
              Everything your program needs, minutes from the track.
            </h2>
          </Reveal>
          <div className="mt-14 grid gap-px bg-neutral-200 sm:grid-cols-2 lg:grid-cols-4">
            {SEBRING_GARAGE.services.map((s, i) => (
              <div key={s.title} className="bg-[#f8f9fa] p-8 md:p-10">
                <Reveal delay={0.05 * i}>
                  <p className="font-overline text-[11px] tracking-[0.25em] text-[#e63946]">
                    {String(i + 1).padStart(2, "0")}
                  </p>
                  <h3 className="font-display mt-4 text-xl font-bold tracking-tight text-[#111111]">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-neutral-600">{s.text}</p>
                </Reveal>
              </div>
            ))}
            <Link
              to="/contact?interest=sebring-garage"
              data-testid="garage-book-tile"
              className="group flex flex-col justify-between bg-[#111111] p-8 text-white transition-colors duration-300 hover:bg-[#e63946] md:p-10"
            >
              <p className="font-overline text-[11px] uppercase tracking-[0.25em] text-[#e63946] transition-colors duration-300 group-hover:text-white">
                Race week at Sebring
              </p>
              <span className="font-display mt-6 flex items-end justify-between gap-4 text-xl font-bold tracking-tight">
                Reserve garage space
                <ArrowUpRight className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      <section data-testid="garage-gallery" className="border-t border-neutral-200 bg-[#f8f9fa]">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          <Reveal>
            <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946] md:text-[11px]">
              Inside the operation
            </p>
            <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-[#111111] sm:text-4xl lg:text-5xl">
              Garage, prep, transport, trackside.
            </h2>
          </Reveal>
          <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {SEBRING_GARAGE.gallery.map((g, i) => (
              <Reveal key={g.src} delay={0.07 * i}>
                <figure data-testid={`garage-image-${i + 1}`}>
                  <img
                    src={g.src}
                    alt={g.alt}
                    width="1000"
                    height="1250"
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover shadow-sm"
                  />
                  <figcaption className="mt-4 text-sm leading-relaxed text-neutral-600">{g.caption}</figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand title="Need a base at Sebring?" accent="Reserve your space now." to="/contact?interest=sebring-garage" label="Reserve Garage Space" />
    </div>
  );
}
